import { forwardRef, type Ref, type SVGProps } from "react";
const IconFlagPointedOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path d="m29.8 20.4-5.52-7.36 5.48-6.39a1.02 1.02 0 0 0 .15-1.07A1 1 0 0 0 29 5H6V4a1 1 0 0 0-2 0v5H3a1 1 0 0 0 0 2h1v5H3a1 1 0 0 0 0 2h1v10a1 1 0 0 0 2 0v-6h23a1 1 0 0 0 .8-1.6M6 20v-2h2a1 1 0 0 0 0-2H6v-5h2a1 1 0 0 0 0-2H6V7h20.83l-4.59 5.35a1 1 0 0 0-.04 1.25L27 20z" />
  </svg>
);
const ForwardRef = forwardRef(IconFlagPointedOutlineSVG);
ForwardRef.displayName = "IconFlagPointedOutline";
export { ForwardRef as IconFlagPointedOutline };
